// D — 重構・見光. Physical material assembly + a real Nanzi case folio.
import {createDWorld} from './d-world.js';
const clamp=(v,a=0,b=1)=>Math.max(a,Math.min(b,v));
const ease=v=>{v=clamp(v);return v*v*(3-2*v);};
const span=(a,b,t)=>ease((t-a)/(b-a));
const mix=(a,b,p)=>a+(b-a)*p;
export async function createD({THREE:T,scene,camera,renderer,portrait=false}){
  const world=await createDWorld({THREE:T,scene,portrait});
  const duration=6.8;let isPortrait=!!portrait,time=0,phase='material';
  const v=new T.Vector3(),target=new T.Vector3();
  function update(seconds){
    time=clamp(seconds,0,duration);
    const held=Math.min(time,5.55),assembly=span(.72,3.62,held),light=span(2.55,4.48,held),documents=span(3.72,5.42,held);
    const open=span(.15,4.62,held),settle=span(4.35,5.55,held);
    const start=isPortrait?[3.8,3.25,7.6]:[2.20,2.15,5.65];
    const end=isPortrait?[6.7,6.10,18.8]:[8.10,6.30,13.7];
    v.set(mix(start[0],end[0],open),mix(start[1],end[1],open),mix(start[2],end[2],open));
    // A quiet arc reveals the physical thickness, never a track through corridors.
    v.x+=Math.sin(Math.PI*open)*(isPortrait?-.8:-1.3);
    const focusStart=isPortrait?[0,.75,.1]:[-1.65,.61,.5];
    const focusEnd=isPortrait?[0,2.75,-.35]:[.10,1.43,-.15];
    target.set(...focusStart.map((n,i)=>mix(n,focusEnd[i],span(.85,5.35,held))));
    camera.position.copy(v);camera.lookAt(target);
    const nextFov=isPortrait?mix(35,30.8,settle):mix(36,32.4,settle);
    if(camera.fov!==nextFov){camera.fov=nextFov;camera.updateProjectionMatrix();}
    renderer.toneMappingExposure=mix(.78,1.10,span(.40,4.40,held));
    // Opacity reveals the complete, original silhouette together. No travelling nib.
    const brand=span(.04,.44,time)*(1-span(.96,1.55,time))*.88;
    world.update({assembly,light,documents,time:held,brand,camera});
    if(renderer.shadowMap)renderer.shadowMap.needsUpdate=true;
    phase=time<.85?'material':time<3.62?'reframe':time<4.55?'daylight':time<5.55?'real-case-folio':'brand-hold';
    scene.userData.intro={variant:'D',title:'重構・見光',time,phase,assembly,light,documents,calligraphy:'complete silhouette opacity; no handwriting',sourceCase:'楠梓區老屋翻修'};
  }
  update(0);
  return {duration,dynamicShadows:true,update,resize(value){isPortrait=!!value;world.resize(isPortrait);update(time);},dispose(){world.dispose();},inspect(){return {...scene.userData.intro,portrait:isPortrait,camera:{position:camera.position.toArray(),target:target.toArray(),fov:camera.fov},world:world.inspect()};}};
}
